
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 36 36"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","d":"M4 11.53h6.026l11.41-7.853c.663-.456 1.564.022 1.564.83v26.985a1 1 0 01-1.565.83l-11.406-7.85H4c-2.21 0-4-1.801-4-4.024v-4.894c0-2.223 1.79-4.025 4-4.025zm6.648 10.97H4c-1.105 0-2-.967-2-2.07v-4.858c0-1.104.895-2.072 2-2.072h6.645L21 6.5v23l-10.352-7z"}}),_c('path',{attrs:{"d":"M31.248 9.584a1 1 0 10-1.168 1.624c2.379 1.71 3.918 4.479 3.918 7.6 0 3.12-1.539 5.889-3.918 7.599a1 1 0 001.168 1.624c2.874-2.067 4.75-5.427 4.75-9.224 0-3.796-1.876-7.156-4.75-9.223z"}}),_c('path',{attrs:{"d":"M28.956 14.118a1 1 0 00-1.366 1.462 4.401 4.401 0 011.408 3.227 4.411 4.411 0 01-1.67 3.455 1 1 0 101.25 1.561 6.411 6.411 0 002.42-5.016c0-1.85-.788-3.516-2.042-4.689z"}})])
          )
        }
      }
    